import * as React from 'react';

function SvgMail(props) {
  return (
    <svg
      width={17}
      height={15}
      fill="none"
      viewBox="0 0 17 15"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.476 0H4.16C1.664 0 0 1.248 0 4.159V9.98c0 2.911 1.664 4.159 4.159 4.159h8.317c2.496 0 4.16-1.248 4.16-4.159V4.16c0-2.911-1.664-4.159-4.16-4.159zm.391 5.065l-2.603 2.08c-.549.44-1.248.657-1.946.657-.699 0-1.406-.216-1.947-.657l-2.603-2.08a.64.64 0 01-.1-.881.622.622 0 01.873-.1l2.604 2.08c.632.507 1.705.507 2.337 0l2.604-2.08a.614.614 0 01.873.1.631.631 0 01-.092.881z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgMail;
